const NDCShoppingReq = (req) => {
  const createTravelerArray = (count, type) =>
    Array.from({ length: count }, () => {
      return {
        PTC: { value: type },
        ...(type === "CHD" ? { Age: { Value: { value: 4 } } } : {}),
        ...(type === "INF" ? { Age: { Value: { value: 0 } } } : {}),
      };
    });

  const travelers = [
    ...createTravelerArray(req.adults, "ADT"),
    ...createTravelerArray(req.chd, "CHD"),
    ...createTravelerArray(req.inf, "INF"),
    ...createTravelerArray(req.labor, "LBR"),
  ].map((traveler) => ({ AnonymousTraveler: [traveler] }));

  const createOriginDestination = (origin, destination, date, key) => ({
    Departure: {
      AirportCode: { value: origin },
      Date: date,
    },
    Arrival: {
      AirportCode: { value: destination },
    },
    OriginDestinationKey: key,
  });

  const originDestinations = req.returnDate
    ? [
        createOriginDestination(
          req.origin,
          req.destination,
          req.departureDate,
          "OD1"
        ),
        createOriginDestination(
          req.destination,
          req.origin,
          req.returnDate,
          "OD2"
        ),
      ]
    : [
        createOriginDestination(
          req.origin,
          req.destination,
          req.departureDate,
          "OD1"
        ),
      ];

  const preference = {
    FarePreferences: {
      Types: {
        Type: [{ Code: "PUBL" }, { Code: "PVT" }],
      },
    },
    ...(req.cabin && {
      CabinPreferences: {
        CabinType: [{ Code: req.cabin }],
      },
    }),
  };

  const responseParameters = {
    ShopResultPreference: "OPTIMIZED",
    SortOrder: [
      { Order: "ASCENDING", Parameter: "STOP" },
      { Order: "ASCENDING", Parameter: "PRICE" },
      { Order: "ASCENDING", Parameter: "DEPARTURE_TIME" },
    ],
  };

  const corporateCode = () => {
    if (req.destination === "DXB") {
      return "EK/EAJ2";
    } else if (req.destination === "IST") {
      return "EK/EAH2";
    } else {
      return "EK/NDC2";
    }
  };

  return {
    Party: {
      Sender: {
        CorporateSender: {
          CorporateCode: corporateCode(),
        },
      },
    },
    // Travelers: { Traveler: [{ AnonymousTraveler: travelers }] },
    Travelers: { Traveler: travelers },
    CoreQuery: {
      OriginDestinations: { OriginDestination: originDestinations },
    },
    Preference: preference,
    ResponseParameters: responseParameters,
  };
};

const headers = {
  "Content-Type": "application/json",
  "Accept-Encoding": "gzip, deflate, br",
  officeId: "OFF102",
  ThirdpartyId: "",
  service: "AirShopping",
  Accept: "*/*",
};

const NDC_API = "https://api.stage.verteil.com/entrygate/rest/request:";

export { NDCShoppingReq, headers, NDC_API };
